import { Container, Form, Button, Alert } from "react-bootstrap";
import { useState } from "react";
import { sendInfoGala } from "../api/api.js";

export default function InfoGala() {
  const initialData = {
    nome_maestro: "",
    cellulare: "",
    team: "",
    cognome: "",
    nome: "",
    link_canzone: "",
    start_time: "00:00:00",
    foto: null,
  };

  const [formData, setFormData] = useState(initialData);
  const [ownerType, setOwnerType] = useState("atleta");
  const [message, setMessage] = useState(null);
  const [messageType, setMessageType] = useState("success");
  const [loading, setLoading] = useState(false);
  const [language, setLanguage] = useState("it");

  const translations = {
    it: {
      title: "Info Galà",
      general: "Anagrafica Generale",
      maestro_name: "Nome e Cognome del Maestro *",
      team: "Team *",
      cognome: "Cognome dell’Atleta *",
      nome: "Nome dell’Atleta *",
      numero_cell: "Numero di Cellulare *",
      atleta: "Atleta",
      maestro: "Maestro",
      song_section: "Canzone d'Ingresso",
      song_link: "Link YouTube o Spotify *",
      start_time: "Minutaggio d'Inizio",
      warning:
        "Verranno usati solo i primi 15 secondi della canzone dal punto di inizio impostato. Utilizzare una canzone consona all'ambiente pubblico.",
      photo_section: "Foto dell'Atleta",
      photo_info: "Foto in posizione di guardia, con sfondo neutro",
      see_example: "Vedi esempio",
      submit: "Invia Registrazione",
      sending: "Invio...",
      success: "Registrazione inviata con successo",
      error: "Errore nell'invio",
      network_error: "Errore di rete durante l'invio",
    },
    en: {
      title: "Gala Info",
      general: "General Information",
      maestro_name: "Master’s Full Name *",
      team: "Team *",
      cognome: "Athlete’s Last Name *",
      nome: "Athlete’s First Name *",
      numero_cell: "Phone Number *",
      atleta: "Athlete",
      maestro: "Master",
      song_section: "Entrance Song",
      song_link: "YouTube or Spotify Link *",
      start_time: "Start Time",
      warning:
        "Only the first 15 seconds of the song will be used from the selected start time. Please choose a song suitable for a public environment.",
      photo_section: "Athlete’s Photo",
      photo_info: "Photo in guard stance, neutral background",
      see_example: "See example",
      submit: "Submit Registration",
      sending: "Sending...",
      success: "Registration sent successfully",
      error: "Submission error",
      network_error: "Network error during submission",
    },
  };

  const t = (key) => translations[language][key] || key;

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (files) {
      setFormData((prev) => ({ ...prev, [name]: files[0] }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage(null);

    try {
      const data = new FormData();
      const finalData = { ...formData };
      const prefix = ownerType === "atleta" ? "A - " : "M - ";
      finalData.cellulare = prefix + finalData.cellulare;

      for (let key in finalData) {
        data.append(key, finalData[key]);
      }

      const res = await sendInfoGala(data);

      if (res.ok) {
        setMessage(res.message || t("success"));
        setMessageType("success");
        setFormData(initialData);
        setOwnerType("atleta");
      } else {
        setMessage(res.error || t("error"));
        setMessageType("danger");
      }
    } catch {
      setMessage(t("network_error"));
      setMessageType("danger");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container className="mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2 className="text-center flex-grow-1">{t("title")}</h2>
        <div className="text-end mb-2">
          <Button
            variant="light"
            onClick={() => setLanguage(language === "it" ? "en" : "it")}
          >
            {language === "it" ? "🇬🇧 English" : "🇮🇹 Italiano"}
          </Button>
        </div>
      </div>

      {message && (
        <Alert
          variant={messageType}
          dismissible
          onClose={() => setMessage(null)}
        >
          {message}
        </Alert>
      )}

      <Form onSubmit={handleSubmit}>
        <h5 className="mb-3">{t("general")}</h5>
        {[
          { label: t("maestro_name"), name: "nome_maestro", type: "text" },
          { label: t("team"), name: "team", type: "text" },
          { label: t("cognome"), name: "cognome", type: "text" },
          { label: t("nome"), name: "nome", type: "text" },
        ].map((field) => (
          <Form.Group className="mb-3" key={field.name}>
            <Form.Label>{field.label}</Form.Label>
            <Form.Control
              type={field.type}
              name={field.name}
              value={formData[field.name]}
              onChange={handleChange}
              required
            />
          </Form.Group>
        ))}

        <Form.Group className="mb-3">
          <Form.Label>{t("numero_cell")}</Form.Label>
          <div className="mb-2">
            <Form.Check
              inline
              type="radio"
              label={t("atleta")}
              name="cellOwner"
              value="atleta"
              checked={ownerType === "atleta"}
              onChange={(e) => setOwnerType(e.target.value)}
            />
            <Form.Check
              inline
              type="radio"
              label={t("maestro")}
              name="cellOwner"
              value="maestro"
              checked={ownerType === "maestro"}
              onChange={(e) => setOwnerType(e.target.value)}
            />
          </div>
          <Form.Control
            type="text"
            name="cellulare"
            value={formData.cellulare}
            onChange={handleChange}
            required
          />
        </Form.Group>

        <Form.Group className="mb-4">
          <h5 className="mb-3">{t("song_section")}</h5>
          <Form.Label>{t("song_link")}</Form.Label>
          <Form.Control
            type="url"
            name="link_canzone"
            value={formData.link_canzone}
            onChange={handleChange}
            required
          />
          <Form.Label className="mt-3">{t("start_time")}</Form.Label>
          <Form.Control
            type="time"
            name="start_time"
            step={1}
            value={formData.start_time}
            onChange={handleChange}
          />
          <Alert variant="warning" className="py-2 mt-3">
            {t("warning")}
          </Alert>
        </Form.Group>

        <Form.Group
          className="mb-3 d-flex flex-column flex-md-row align-items-start justify-content-between"
        >
          <div className="flex-grow-1 me-md-3 mb-3 mb-md-0">
            <h5 className="mb-3">{t("photo_section")}</h5>
            <Form.Control
              type="file"
              name="foto"
              accept="image/png, image/jpeg"
              onChange={handleChange}
              required
            />
            <Alert variant="info" className="py-2 mt-2 mb-0">
              {t("photo_info")}
            </Alert>
          </div>

          <div
            style={{
              width: "120px",
              height: "130px",
              overflow: "hidden",
              borderRadius: "8px",
              flexShrink: 0,
            }}
          >
            <img
              src="/template.png"
              alt="Example"
              style={{
                width: "100%",
                height: "180px",
                objectFit: "cover",
                objectPosition: "center 180%", // taglia dall'alto
              }}
            />
          </div>
        </Form.Group>

        <Button type="submit" className="w-100" disabled={loading}>
          {loading ? t("sending") : t("submit")}
        </Button>
      </Form>
    </Container>
  );
}
